// GENERATED by scripts/generate-image-sizes.ts — do not edit by hand.
// Run `npx tsx scripts/generate-image-sizes.ts` (or `npm run build`) to refresh.
//
// Maps an asset file name to its intrinsic [width, height] in pixels, so that
// components rendering globbed/hashed image URLs can still emit width and
// height attributes. Resolve a URL with getImageSize() from './imageSize'.

export const imageSizes: Record<string, [number, number]> = {
  'a1_logo_white.webp': [200, 71],
  'abacus-logo.webp': [96, 17],
  'analyst_small.webp': [381, 375],
  'analyst.webp': [1080, 1350],
  'analyzer_platform.webp': [4634, 2780],
  'analyzer.webp': [4968, 3728],
  'answer-with-table.webp': [2000, 2481],
  'approval-rework.webp': [927, 430],
  'aptean_white.webp': [200, 53],
  'Aptean-black-logo_large.webp': [128, 34],
  'Azure-logo_large.webp': [128, 29],
  'banking_noreja.webp': [1254, 1254],
  'Banking.webp': [1405, 790],
  'bigquery-logo.webp': [96, 96],
  'BOC-logo-white.webp': [300, 345],
  'builder_platform.webp': [4632, 2766],
  'builder_small.webp': [278, 361],
  'calculation-rework.webp': [971, 467],
  'capacity-to-payment.webp': [1517, 682],
  'capital-management.webp': [1024, 1024],
  'car_production_noreja.webp': [1254, 1254],
  'cash_management_noreja.webp': [1254, 1254],
  'cash-discount-loss.webp': [1775, 275],
  'cash-discount-payments.webp': [990, 614],
  'changeenablers_logo.webp': [165, 157],
  'chat-start.webp': [2000, 1233],
  'christian_riffner_novofactum.webp': [300, 300],
  'christian_waits.webp': [400, 400],
  'Christian-Riffner.webp': [800, 800],
  'Christoph_Blum_fortlane.webp': [300, 200],
  'cib_contact_de.webp': [744, 271],
  'cib_decisions_de.webp': [1555, 204],
  'cib_flexiblity_de.webp': [1089, 595],
  'cib_logo_white.webp': [284, 128],
  'claims_noreja.webp': [1254, 1254],
  'claims-optimisation.webp': [1024, 1024],
  'cockroachdb-logo.webp': [96, 96],
  'comarch-logo.webp': [96, 96],
  'comatic-logo.webp': [96, 16],
  'complaints-management-view.webp': [1492, 1218],
  'compliance_small.webp': [313, 379],
  'compliance.webp': [1080, 1350],
  'construction-seasonality.webp': [2000, 496],
  'context-hub.webp': [2000, 964],
  'context.webp': [165, 165],
  'Daniel-Bauer.webp': [488, 408],
  'dashboard_platform.webp': [4614, 2772],
  'dashboard.webp': [5830, 2999],
  'defect-waste-reduction.webp': [1024, 1024],
  'delivery-invoicing.webp': [2000, 593],
  'dynamics-logo_large.webp': [128, 72],
  'emissions-tracking.webp': [1024, 1024],
  'end-to-end-perspective.webp': [2000, 792],
  'episode-1-organisatorische-huerden.webp': [1080, 1350],
  'episode-2-process-mining-impact.webp': [1080, 1350],
  'episode-3-prozessaufnahme-process-mining.webp': [1080, 1350],
  'episode-4-it-blocker-ki.webp': [1080, 1350],
  'episode-5-ki-in-produkten.webp': [1080, 1350],
  'event-knowledge-graph.webp': [1422, 866],
  'fast_packaging_noreja.webp': [1254, 1254],
  'fast.webp': [164, 164],
  'file-created.webp': [2000, 1149],
  'filed-not-paid.webp': [1297, 437],
  'filing-before-approval.webp': [872, 477],
  'firebird-logo.webp': [64, 64],
  'florian_lindermayr_juzo.webp': [500, 500],
  'Florian-Eichin.webp': [400, 399],
  'fortlane_logo.webp': [266, 47],
  'fortlane_white.webp': [266, 47],
  'franz_mensch_logo_white.webp': [200, 63],
  'fraud-detection-banking.webp': [1024, 1024],
  'fraud-detection.webp': [1024, 1024],
  'friwo_logo_white_xlarge.webp': [250, 250],
  'fulfilment-paths.webp': [2000, 1021],
  'gdpr_white.webp': [512, 512],
  'gordana_mcnamara.webp': [300, 450],
  'Gordana-McNamara.webp': [591, 591],
  'grundeigentümerversicherung_logo_white.webp': [250, 103],
  'handover-compliance.webp': [2000, 539],
  'hector_logo_white.webp': [206, 40],
  'high_tech_production_noreja.webp': [1254, 1254],
  'hr_noreja.webp': [1254, 1254],
  'Hubspot-logo.webp': [96, 28],
  'humboldt_logo.webp': [300, 122],
  'idm_logo_white.webp': [80, 80],
  'impact-board-kanban.webp': [1770, 917],
  'impact-board-matrix.webp': [1290, 1000],
  'impact-board-quadrangle.webp': [972, 900],
  'impact-board-roi.webp': [991, 1310],
  'impact-board.webp': [2000, 1204],
  'inspection-batches.webp': [1815, 644],
  'inspection-time-pattern.webp': [2000, 814],
  'Insurance.webp': [1405, 790],
  'inventory-optimization.webp': [1024, 1024],
  'invoice-rework.webp': [1732, 1036],
  'invoice-ticket-context.webp': [2000, 744],
  'iso_white.webp': [64, 64],
  'Jira-logo.webp': [96, 38],
  'juzo_logo_white.webp': [1246, 578],
  'kbc_white.webp': [300, 167],
  'loan-application-approval-.webp': [1024, 1024],
  'logistic_noreja.webp': [1254, 1254],
  'manager_platform.webp': [4638, 2778],
  'Manufacturing.webp': [1405, 790],
  'marcel_schober_nexigo.webp': [309, 309],
  'mariadb-logo.webp': [96, 78],
  'markus_neumayr_locker_aptean.webp': [300, 450],
  'Markus-Neumayr.webp': [400, 400],
  'marmot.webp': [777, 792],
  'Matthias-Brengartner.webp': [400, 600],
  'maverick-attributes.webp': [1867, 919],
  'maverick-buying.webp': [1006, 1283],
  'Mendling.webp': [400, 500],
  'metasfresh-logo.webp': [96, 14],
  'michael_grasse_hector.webp': [551, 551],
  'minautics_logo.webp': [300, 133],
  'minerva-agents-vs-llm.webp': [1600, 786],
  'minerva-cause-model.webp': [1068, 1050],
  'minerva-complaint-reasons.webp': [861, 815],
  'minerva-first-cause-picture.webp': [1333, 665],
  'minerva-key-statements.webp': [1057, 231],
  'minerva-next-to-analyzer.webp': [2000, 1038],
  'minerva-structural-deviations.webp': [1133, 1303],
  'minerva-summary.webp': [1340, 685],
  'minerva.webp': [5604, 3404],
  'miragon_white.webp': [300, 47],
  'model-picker.webp': [2000, 735],
  'Monika-Leitner.webp': [400, 400],
  'ms-access-logo.webp': [96, 60],
  'mssql-logo_large.webp': [128, 32],
  'multidimensional.webp': [165, 165],
  'mysql_logo.webp': [96, 65],
  'naehrboden_logo.webp': [200, 110],
  'Neo4j_logo_xlarge.webp': [256, 70],
  'nexigo_logo.webp': [895, 259],
  'nexigo_white.webp': [895, 259],
  'niklas_breidert_von_eicken.webp': [300, 417],
  'niyi_changeenablers.webp': [300, 353],
  'nordlb_logo_white.webp': [300, 103],
  'noreja_gartner_coolest_vendor_innovation.webp': [400, 233],
  'noreja_logo_white.webp': [1566, 405],
  'novofactum_logo.webp': [250, 100],
  'novofactum_white.webp': [250, 100],
  'o2c-causal-perspective.webp': [1995, 706],
  'o2c-entity-graph.webp': [1621, 918],
  'o2c-hypothesis-tree.webp': [1889, 761],
  'o2c-kpi-report.webp': [1176, 876],
  'Odoo-logo.webp': [96, 30],
  'office_noreja.webp': [1254, 1254],
  'oracle-logo_large.webp': [128, 16],
  'order-entry-release.webp': [1277, 669],
  'Oxaion-logo.webp': [96, 47],
  'packaging_noreja.webp': [1254, 1254],
  'payment-dunning-complaints.webp': [2000, 1193],
  'Pfahlsberger.webp': [400, 400],
  'philipp_berger_kbc.webp': [490, 509],
  'pirmin_mutter_fortlane.webp': [413, 414],
  'postgres_logo.webp': [93, 96],
  'proAlpha-logo_large.webp': [128, 66],
  'process_management_noreja.webp': [1254, 1254],
  'production_noreja.webp': [1254, 1254],
  'production-line-optimization.webp': [1024, 1024],
  'pwc_logo-white.webp': [600, 382],
  'pwc_logo.webp': [300, 191],
  'reality.webp': [165, 164],
  'redshift-logo.webp': [96, 96],
  'regulatory-compliance.webp': [1024, 1024],
  'risk-management.webp': [1024, 1024],
  'robin_lange_vienesse.webp': [300, 400],
  'sage-logo.webp': [96, 54],
  'sales-rework.webp': [2000, 391],
  'SAP_logo.webp': [96, 48],
  'schleswiger_white.webp': [300, 100],
  'schrempp-logo.webp': [96, 96],
  'selectline-logo.webp': [96, 27],
  'ServiceNow_logo_large.webp': [128, 19],
  'sesotec_logo_white.webp': [350, 175],
  'skill-picker.webp': [2000, 668],
  'skipped-order-review.webp': [1521, 733],
  'Snowflake-logo_large.webp': [128, 29],
  'Software-Development.webp': [1405, 790],
  'special-features-drilldown.webp': [1052, 691],
  'special-values-refinement.webp': [1111, 814],
  'SQLite-logo.webp': [96, 44],
  'stefan_best_schleswiger.webp': [300, 300],
  'steven_knoblich_zalando.webp': [300, 300],
  'Steven-Knoblich.webp': [500, 500],
  'stop-after-reconciliation.webp': [937, 455],
  'supplier-performance.webp': [2000, 809],
  'Supply-Chain.webp': [1405, 790],
  'tabaco_production.webp': [1254, 1254],
  'tatjana_meyer_nordlb.webp': [300, 297],
  'Temu-new.webp': [400, 484],
  'teradata-logo_large.webp': [128, 82],
  'thomas_heinrichs_miragon.webp': [300, 300],
  'thomas_hofer_untha.webp': [240, 240],
  'traceable-steps.webp': [2000, 906],
  'trade-coordination.webp': [2000, 619],
  'Tryton-logo.webp': [96, 25],
  'untha_logo_white.webp': [250, 114],
  'vienesse_logo_white.webp': [134, 99],
  'vienesse_logo.webp': [300, 231],
  'Violeta-Petkova.webp': [400, 483],
  'Von_Eicken_logo_white.webp': [283, 142],
  'Waibel.webp': [400, 400],
  'waits_white.webp': [300, 64],
  'workbench_platform.webp': [4640, 2784],
  'workbench.webp': [6291, 3314],
  'working-capital.webp': [1024, 1024],
  'wu_logo_white.webp': [776, 479],
  'zalando_wordmark_white_RGB.webp': [3000, 570],
};
